function getSampleAlias (sampleId) {
  if (!this.samples) return
  if (!sampleId) return
  const sample = this.samples[sampleId]
  if (!sample) return
  return sample.alias
}

export default getSampleAlias